<div class="sentiment-details-heatmap-analysis">
  <div class="sentiment-details-heatmap-analysis__header">
    <div>
      <h3 class="sentiment-details-heatmap-analysis__title">Category Heatmap Analysis</h3>
      <p class="sentiment-details-heatmap-analysis__subtitle">Click a row (theme or total) or a cell to load customer feedback</p>
    </div>
    <div class="sentiment-details-heatmap-analysis__filters">
      <select class="sentiment-details-heatmap-analysis__select" [value]="levelFilter" (change)="levelFilterChange.emit($any($event.target).value)">
        <option value="Themes">Themes</option>
        <option value="Sub-themes">Sub-themes</option>
      </select>
      <select class="sentiment-details-heatmap-analysis__select" [value]="themeFilterValue ?? 'all'" (change)="themeFilterChange.emit($any($event.target).value)">
        <option value="all">All Themes</option>
        <option *ngFor="let t of themes" [value]="t.themeId">{{ t.themeName }}</option>
      </select>
      <select
        class="sentiment-details-heatmap-analysis__select"
        [ngModel]="cohortFilterValue"
        (ngModelChange)="cohortFilterChange.emit($event)"
        [ngModelOptions]="{standalone: true}"
        [disabled]="cohortFilterOptions.length === 0"
      >
        <option *ngIf="cohortFilterOptions.length === 0" value="" disabled>No cohort filters configured</option>
        <option *ngFor="let o of cohortFilterOptions" [value]="o.value">{{ o.label }}</option>
      </select>
      <button
        *ngIf="levelFilter === 'Sub-themes'"
        type="button"
        class="sentiment-details-heatmap-analysis__back-btn"
        (click)="onBackToThemes()"
      >
        Back to themes
      </button>
      <div class="sentiment-details-heatmap-analysis__toggle">
        <button type="button" class="sentiment-details-heatmap-analysis__toggle-btn" [class.sentiment-details-heatmap-analysis__toggle-btn--active]="sentimentMode === 'non_negative'" (click)="setSentimentMode('non_negative')">Non-negative %</button>
        <button type="button" class="sentiment-details-heatmap-analysis__toggle-btn sentiment-details-heatmap-analysis__toggle-btn--red" [class.sentiment-details-heatmap-analysis__toggle-btn--active]="sentimentMode === 'negative'" (click)="setSentimentMode('negative')">Negative %</button>
      </div>
    </div>
  </div>
  <div class="sentiment-details-heatmap-analysis__content">
    <div class="sentiment-details-heatmap-analysis__left">
      <div #leftStackMeasureRoot class="sentiment-details-heatmap-analysis__left-stack">
        <div class="sentiment-details-heatmap-analysis__card sentiment-details-heatmap-analysis__card--legend">
          <h4 class="sentiment-details-heatmap-analysis__card-title">Color Intensity Calculation</h4>
          <p class="sentiment-details-heatmap-analysis__formula">(Volume Weight x 60%) + (Sentiment Impact x 40%)</p>
          <p class="sentiment-details-heatmap-analysis__note">Applied to cells with fewer than 30 responses (configurable threshold).</p>
          <p class="sentiment-details-heatmap-analysis__def"><strong>Volume Weight:</strong> {{ volumeWeightLegend }}</p>
          <p class="sentiment-details-heatmap-analysis__def"><strong>Sentiment Impact:</strong> Percentage of positive/negative sentiment (0-100%).</p>
          <p class="sentiment-details-heatmap-analysis__def"><strong>Color Ranges:</strong> Light (0-40%), Medium (40-70%), Dark (70%+).</p>
          <div class="sentiment-details-heatmap-analysis__swatches">
            <span class="sentiment-details-heatmap-analysis__swatch sentiment-details-heatmap-analysis__swatch--gray">Low volume (&lt;30)</span>
            <span class="sentiment-details-heatmap-analysis__swatch" [ngClass]="sentimentMode === 'negative' ? 'sentiment-details-heatmap-analysis__swatch--low-red' : 'sentiment-details-heatmap-analysis__swatch--low-green'">Low impact</span>
            <span class="sentiment-details-heatmap-analysis__swatch" [ngClass]="sentimentMode === 'negative' ? 'sentiment-details-heatmap-analysis__swatch--mid-red' : 'sentiment-details-heatmap-analysis__swatch--mid-green'">Medium impact</span>
            <span class="sentiment-details-heatmap-analysis__swatch" [ngClass]="sentimentMode === 'negative' ? 'sentiment-details-heatmap-analysis__swatch--high-red' : 'sentiment-details-heatmap-analysis__swatch--high-green'">High impact</span>
          </div>
        </div>
        <div class="sentiment-details-heatmap-analysis__heatmap-measure">
          <p class="sentiment-details-heatmap-analysis__select-theme-msg" *ngIf="showSelectThemeMessage">Select a theme to view sub-themes heatmap</p>
          <div class="sentiment-details-heatmap-analysis__card sentiment-details-heatmap-analysis__card--heatmap" *ngIf="!showSelectThemeMessage">
            <ng-content select="[heatmap-table]"></ng-content>
          </div>
        </div>
      </div>
    </div>
    <div class="sentiment-details-heatmap-analysis__right">
      <div
        #feedbackCardRoot
        class="sentiment-details-heatmap-analysis__card sentiment-details-heatmap-analysis__card--feedback"
        [style.height.px]="feedbackCardHeightPx ?? null"
        [style.max-height.px]="feedbackCardHeightPx ?? null"
      >
        <h4 class="sentiment-details-heatmap-analysis__card-title">Customer Feedback</h4>
        <div
          class="sentiment-details-heatmap-analysis__feedback-placeholder"
          (scroll)="onFeedbackPlaceholderScroll($event)"
        >
          <p class="sentiment-details-heatmap-analysis__feedback-empty" *ngIf="!selectedCell">Click a heatmap row or cell to view customer feedback</p>
          <div class="sentiment-details-heatmap-analysis__feedback-selected" *ngIf="selectedCell">
            <div class="sentiment-details-heatmap-analysis__feedback-selected-top">
              <p class="sentiment-details-heatmap-analysis__feedback-selected-title">{{ selectedCell.rowLabel }} – {{ selectedCell.columnLabel }}</p>
              <p class="sentiment-details-heatmap-analysis__feedback-selected-meta">
                <span *ngIf="selectedCell.percentage != null">{{ selectedCell.percentage | number:'1.2-2' }}%</span>
                <span>{{ selectedCell.count | number }} sentiment responses<ng-container *ngIf="selectedCell.total != null"> (out of {{ selectedCell.total | number }} total)</ng-container></span>
              </p>
            </div>
            <div *ngIf="feedbackLoading" class="sentiment-details-heatmap-analysis__feedback-loading">
              <span class="sentiment-details-heatmap-analysis__feedback-spinner"></span>
              <span>Loading feedback...</span>
            </div>
            <div
              *ngIf="!feedbackLoading && feedbackList.length === 0 && selectedCell"
              class="sentiment-details-heatmap-analysis__feedback-no-items-wrap"
            >
              <p class="sentiment-details-heatmap-analysis__feedback-no-items">No feedback found for this selection</p>
            </div>
            <div
              *ngIf="!feedbackLoading && feedbackList.length > 0"
              class="sentiment-details-heatmap-analysis__feedback-list"
            >
              <div *ngFor="let f of feedbackList" class="sentiment-details-heatmap-analysis__feedback-item">
                <div class="sentiment-details-heatmap-analysis__feedback-item-meta">
                  <span
                    class="sentiment-details-heatmap-analysis__feedback-badge"
                    [class.sentiment-details-heatmap-analysis__feedback-badge--negative]="f.sentiment === 'negative'"
                    [class.sentiment-details-heatmap-analysis__feedback-badge--positive]="f.sentiment === 'positive'"
                  >
                    {{ f.sentiment }}
                  </span>
                  <button
                    *ngIf="showFeedLinkRedirect && f.feedId"
                    type="button"
                    class="sentiment-details-heatmap-analysis__feedback-open"
                    (click)="openFeedbackDetails.emit(f.feedId!); $event.stopPropagation()"
                    aria-label="Open feedback details"
                  >
                    <img
                      class="sentiment-details-heatmap-analysis__feedback-open-icon sentiment-details-heatmap-analysis__feedback-open-icon--default"
                      src="assets/images/launch.svg"
                      alt=""
                    />
                    <img
                      class="sentiment-details-heatmap-analysis__feedback-open-icon sentiment-details-heatmap-analysis__feedback-open-icon--active"
                      src="assets/images/blue-link-icon.svg"
                      alt=""
                    />
                  </button>
                </div>
                <p class="sentiment-details-heatmap-analysis__feedback-text">{{ f.text }}</p>
                <div
                  *ngIf="showCohortFooter && f.cohortTagsFooter.length"
                  class="sentiment-details-heatmap-analysis__feedback-footer"
                  aria-label="Cohort"
                >
                  <span
                    *ngFor="let tag of f.cohortTagsFooter"
                    class="sentiment-details-heatmap-analysis__feedback-footer-chip"
                  >
                    <span class="sentiment-details-heatmap-analysis__feedback-footer-key">{{ tag.label }}</span>
                    <span class="sentiment-details-heatmap-analysis__feedback-footer-value">{{ tag.value }}</span>
                  </span>
                </div>
              </div>
              <div *ngIf="feedbackLoadingMore" class="sentiment-details-heatmap-analysis__feedback-load-more">
                <span class="sentiment-details-heatmap-analysis__feedback-spinner"></span>
                <span>Loading more…</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
